import { RouteName } from "@/router/index";

export const authTokenPresentGuard = (to: any) => {
  if (to.query.token) return true;
  return { name: RouteName.HOME_VIEW };
};
